import { render, staticRenderFns } from "./addNewAddress.vue?vue&type=template&id=4aa3ace0&scoped=true&"
import script from "./addNewAddress.vue?vue&type=script&lang=ts&"
export * from "./addNewAddress.vue?vue&type=script&lang=ts&"
import style0 from "./addNewAddress.vue?vue&type=style&index=0&id=4aa3ace0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3ace0",
  null
  
)

export default component.exports